import React from "react";
import Loadable, { LoadingComponentProps } from "react-loadable";
import { connect } from "react-redux";

// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";

// components
import { Null } from "@clockwise/web-commons/src/components/null";

// internal
import { IRendererProps } from "./SettingsDialog.d";

interface IContainer extends LoadingComponentProps {}

interface IProps extends IContainer {
  setSettingsDialogOpen: typeof setSettingsDialogOpen;
}

class SettingsDialogLoadingComponent extends React.Component<IProps> {
  public UNSAFE_componentWillMount() {
    if (this.props.error) {
      this.props.retry();
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.error) {
      this.props.setSettingsDialogOpen(false);
    }
  }

  public render() {
    return <Null />;
  }
}

///////////
// Redux //
///////////

function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SettingsDialogLoading = connect(mapStateToProps, {
  setSettingsDialogOpen,
})(SettingsDialogLoadingComponent);

//////////////
// Loadable //
//////////////

export const SettingsDialog = Loadable({
  loader: () =>
    import(/* webpackChunkName: "settings-dialog" */ "./SettingsDialogRenderer").then(
      ({ SettingsDialogRenderer: c }) => c,
    ),
  loading: SettingsDialogLoading,
}) as React.ComponentClass<IRendererProps>;
